import React from 'react';

const legendBoxStyle = {
  background: 'rgba(255, 255, 255, 0.5)',
  border: '1px solid #ccc',
  borderRadius: 3,
  boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
  padding: '2px 6px',
};

export function GScaleLegend({ guides = [] }) {
  if (!guides.length) return null;

  return (
    <div style={{ ...legendBoxStyle }}>
      {guides.map((guide) => (
        <div
          key={guide.label}
          style={{ display: 'flex', alignItems: 'center', gap: 3, lineHeight: 1.1 }}
        >
          <span
            style={{
              width: 8,
              height: 8,
              background: guide.color,
              borderRadius: 2,
              flexShrink: 0,
            }}
          />
          <span style={{ fontSize: 9, whiteSpace: 'nowrap' }}>
            {guide.label} ({guide.value}{guide.valueSuffix !== undefined ? guide.valueSuffix : ' nT'})
          </span>
        </div>
      ))}
    </div>
  );
}

export default function Legend({ lineColor, label, onClose }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        ...legendBoxStyle,
        position: 'relative',
      }}
    >
      <div
        style={{
          width: 10,
          height: 10,
          background: lineColor,
          borderRadius: 2,
          flexShrink: 0,
        }}
      />
      <span style={{ fontSize: 9, fontWeight: 400, lineHeight: 1.1 }}>{label}</span>
    </div>
  );
}
